import React, { useState, useEffect } from "react";
import {
  MenuItem,
  Select,
  FormControl,
  TextField,
  Button,
  IconButton,
  Box,
} from "@material-ui/core";

import { Delete as DeleteIcon } from "@material-ui/icons";
import FormSection from "../ui/forms/input/FormSection";

const MessageAutomaticDistribution = ({ value, onChange }) => {
  const [type, setType] = useState("");
  const [patterns, setPatterns] = useState([]);

  useEffect(() => {
    if (!value || value === "") {
      setType("");
      setPatterns([]);
    } else if (value === "reg") {
      setType("reg");
      setPatterns([]);
    } else if (value.startsWith("email:")) {
      setType("email");
      const raw = value
        .substring(6)
        .split("|")
        .map((p) => p.trim());
      setPatterns(
        raw.map((p) => ({
          kind: p.startsWith("e:") ? "e" : "s",
          value: p.substring(2),
        }))
      );
    }
  }, [value]);

  const handleTypeChange = (event) => {
    const newType = event.target.value;
    setType(newType);
    if (newType === "" || newType === "reg") {
      onChange(newType);
      setPatterns([]);
    } else if (newType === "email") {
      onChange("email:");
    }
  };

  const updatePatterns = (newPatterns) => {
    setPatterns(newPatterns);
    const formatted = newPatterns.map((p) => `${p.kind}:${p.value}`);
    onChange(`email:${formatted.join("|")}`);
  };

  const handleAdd = () => {
    updatePatterns([...patterns, { kind: "e", value: "" }]);
  };

  const handlePatternChange = (index, key, val) => {
    const newPatterns = [...patterns];
    newPatterns[index][key] = val;
    updatePatterns(newPatterns);
  };

  const handleDelete = (index) => {
    const newPatterns = patterns.filter((_, i) => i !== index);
    updatePatterns(newPatterns);
  };

  const isDuplicate = (value, kind, index) =>
    patterns.some(
      (p, i) => i !== index && p.kind === kind && p.value === value
    );

  return (
    <FormSection title="Distribuzione automatica" collapsed={true}>
      <FormControl fullWidth>
        <Select
          value={type}
          onChange={handleTypeChange}
          displayEmpty
          renderValue={(selected) => {
            if (selected === "") return "Nessuna";
            if (selected === "reg") return "Alla registrazione";
            if (selected === "email") return "E-mail pattern";
            return selected;
          }}
        >
          <MenuItem value="">Nessuna</MenuItem>
          <MenuItem value="reg">Alla registrazione</MenuItem>
          <MenuItem value="email">E-mail pattern</MenuItem>
        </Select>
      </FormControl>

      {type === "email" && (
        <Box mt={2}>
          {patterns.map((p, index) => {
            const duplicate = isDuplicate(p.value, p.kind, index);
            return (
              <Box key={index} display="flex" alignItems="center" mb={1}>
                <Select
                  value={p.kind}
                  onChange={(e) =>
                    handlePatternChange(index, "kind", e.target.value)
                  }
                >
                  <MenuItem value="e">E-mail</MenuItem>
                  <MenuItem value="s">Suffix</MenuItem>
                </Select>
                <TextField
                  style={{ marginLeft: 8, flex: 1 }}
                  value={p.value}
                  error={duplicate}
                  helperText={duplicate ? "Duplicate pattern" : ""}
                  onChange={(e) =>
                    handlePatternChange(index, "value", e.target.value)
                  }
                />
                <IconButton onClick={() => handleDelete(index)}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            );
          })}
          <Button variant="outlined" onClick={handleAdd}>
            Aggiungi Pattern
          </Button>
        </Box>
      )}
    </FormSection>
  );
};

export default MessageAutomaticDistribution;
